






































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class PdfViewer extends Vue {
  @Prop({ required: true }) contentUrl!: string;
  @Prop({ required: true }) contentTitle!: string;

  loading = true;
  downloading = false;

  get pdfTitle() {
    return this.contentTitle || "PDF Document";
  }

  get pdfUrl() {
    // Add parameters to hide toolbar and set zoom to fit width
    return this.contentUrl + '#toolbar=0&navpanes=0&scrollbar=0&view=FitH';
  }

  mounted() {
    // Set a timeout to hide loader if iframe doesn't trigger load event
    setTimeout(() => {
      if (this.loading) {
        this.loading = false;
      }
    }, 2000);
  }

  onPdfLoad() {
    // Hide loader when iframe loads
    this.loading = false;
  }

  async downloadPdf() {
    if (!this.contentUrl) return;

    this.downloading = true;
    try {
      const response = await fetch(this.contentUrl);
      if (!response.ok) throw new Error("Failed to fetch PDF");
      
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = this.getFileName();
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      
      // Clean up
      setTimeout(() => {
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }, 100);
    } catch (e) {
      console.error("Download failed:", e);
      
      // Fallback: try opening in new tab with download attribute
      try {
        const a = document.createElement("a");
        a.href = this.contentUrl;
        a.download = this.getFileName();
     
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (fallbackError) {
        alert("Failed to download PDF. Please try again.");
      }
    } finally {
      this.downloading = false;
    }
  }

  private getFileName(): string {
    let name = this.contentTitle.replace(/[<>:"/\\|?*]/g, "_").trim();
    if (!name.toLowerCase().endsWith(".pdf")) {
      name += ".pdf";
    }
    return name;
  }
}
